import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const userMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/private\/users\/transactions\/favorites/,
    response: () => ecommbx.favoriteTransactionsListData,
    method: 'get',
  },
  {
    url: /\/api\/private\/users\/transactions\/favorites/,
    response: () => ecommbx.favoriteTransactionPostData,
    method: 'post',
  },
  {
    url: /\/api\/private\/users\/transactions\/favorites\/\d+/,
    response: () => ecommbx.editFavoriteTransactionData,
    method: 'put',
  },
  {
    url: /\/api\/private\/users\/transactions\/favorites\/\d+/,
    response: () => null,
    method: 'delete',
    responseHeaders: { code: '204' },
  },
  { url: /\/api\/private\/users\/phone/, response: () => ecommbx.phoneUsersData, method: 'put' },
  {
    url: /\/api\/private\/users\/phone\/authorization/,
    response: () => ecommbx.otpPhoneAuthorizationData,
    method: 'post',
  },
  {
    url: /\/api\/private\/users\/password/,
    response: () => null,
    responseHeaders: { code: '204' },
    method: 'put',
  },
  {
    url: /\/api\/private\/users\/username/,
    response: () => ecommbx.changeUsernameData,
    responseHeaders: { code: '200' },
    method: 'put',
  },
  {
    url: /\/api\/private\/users\/username\/authorization/,
    response: () => ecommbx.changeUsernameAuthorizationData,
    method: 'post',
  },
  {
    url: /\/api\/private\/users\/username\/rules/,
    response: () => ecommbx.usernameRulesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/users\/password\/authorization/,
    response: () => ecommbx.changePasswordAuthorizationData,
    method: 'get',
  },
  {
    url: /\/api\/private\/users\/password\/policy/,
    response: () => ecommbx.passwordPolicyData,
    method: 'get',
  },
  {
    url: /\/api\/private\/users\/beneficiaries\/\d+\/\d+/,
    response: () => ecommbx.beneficiaryData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/users\/beneficiaries\/\d+\/\d+/,
    response: () => ecommbx.postBeneficiaryData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/users\/beneficiaries\/\d+\/\d+/,
    response: () => ecommbx.editBeneficiaryData,
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/users\/beneficiaries\/\d+\/\d+/,
    response: () => ecommbx.deleteBeneficiaryData,
    method: 'delete',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/users\/beneficiaries\/\d+/,
    response: () => ecommbx.beneficiariesData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/public\/users\/email/,
    response: () => ecommbx.verifyEmailData,
    responseHeaders: { code: '200' },
    method: 'post',
  },
  {
    url: /\/api\/private\/users\/consent/,
    response: () => ecommbx.consentData,
    responseHeaders: { code: '200' },
    method: 'patch',
  },
  {
    url: /\/api\/private\/users\/communication-preferences/,
    response: () => ecommbx.communicationAlertsData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/users\/communication-preferences\/groups\/\d+\/categories\/\d+/,
    response: () => ({}),
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/users\/communication-preferences\/groups\/\d+\/categories\/\d+\/tasks\/\d+/,
    response: () => ({}),
    method: 'put',
    responseHeaders: { code: '204' },
  },
];

const userHandlers = userMap.map(genericMapToHandlers);

export { userHandlers };
